import SockJS from 'sockjs-client';

export const getWebsocket = (urlBase: string) =>
  new SockJS(urlBase, undefined, { transports: ['websocket'], timeout: 10_000 });
